import BottomSheetContent from '../../../../../components/BottomSheetComponents/BottomSheetContent'
import { InfoIcon } from '../../../../../icons/rebalance/InfoIcon'
import { useBottomSheet } from '../../../../../state-management/contexts/BottomSheetContext'
import { roundOffAndFormatNumberWithCurrency } from '../../../../../utils/utils'
import {
  ELITE_PRIME_UPGRADE_ADJUSTMENT_INFO,
  ELITE_PRIME_UPGRADE_ADJUSTMENT_SUFFIX
} from '../../../constants/ctaCopy'

type ElitePlansUpgradeAdjustmentNoteProps = {
  adjustmentFromCurrentPlan: number
}

export function ElitePlansUpgradeAdjustmentNote({
  adjustmentFromCurrentPlan
}: ElitePlansUpgradeAdjustmentNoteProps) {
  const { openBottomSheet, closeBottomSheet } = useBottomSheet()
  const amountLabel = roundOffAndFormatNumberWithCurrency(adjustmentFromCurrentPlan)

  const handleInfoClick = () => {
    openBottomSheet(
      <BottomSheetContent onDismiss={closeBottomSheet} heading='Plan adjustment'>
        <p className='pb-6 text-sm leading-[1.5] text-grey40'>{ELITE_PRIME_UPGRADE_ADJUSTMENT_INFO}</p>
      </BottomSheetContent>
    )
  }

  return (
    <div className='mt-3 flex items-center justify-center gap-1 text-13 font-medium leading-[1.4] text-[color:var(--ep-hero-strong)]'>
      <p>
        {amountLabel}
        {ELITE_PRIME_UPGRADE_ADJUSTMENT_SUFFIX}
      </p>
      <button
        type='button'
        className='inline-flex shrink-0 border-none bg-transparent p-0 text-[color:var(--ep-hero-strong)]'
        aria-label='About plan adjustment'
        onClick={handleInfoClick}
      >
        <InfoIcon width={14} height={14} stroke='currentColor' />
      </button>
    </div>
  )
}
